import logger from '../../utils/logger';
import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...', color = 'blue' }) => {
  const sizeClass = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  }[size] || 'w-8 h-8';
  
  const colorClass = {
    blue: 'text-blue-600',
    indigo: 'text-indigo-600',
    white: 'text-white',
    gray: 'text-gray-500'
  }[color] || 'text-blue-600';
  
  // If small, use inline display instead of flex-col
  const containerClass = size === 'small' 
    ? "flex items-center" 
    : "flex flex-col items-center justify-center p-4";
    
  // If small, adjust message margin
  const messageClass = size === 'small'
    ? "ml-2 text-xs"
    : "mt-2 text-gray-600 dark:text-gray-400";

  return (
    <div className={containerClass}>
      <Loader className={`${sizeClass} ${colorClass} animate-spin`} />
      {message && <p className={messageClass}>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;